export default "__VITE_ASSET__BMX3ehDl__";